export const primary = {
  main: '#003A70',
  dark: '#002446',
  shades50p: 'rgba(0, 58, 112, 0.50)',
  shades4p: 'rgba(0, 58, 112, 0.04)',
  shades30p: 'rgba(0, 58, 112, 0.30)',
}

export const primaryLkm = {
  main: '#f7941d',
  dark: '#f38500',
  shades50p: 'rgba(247,148,28, 0.50)',
  shades4p: 'rgba(247,148,28, 0.04)',
  shades30p: 'rgba(247,148,28, 0.30)',
}

export const secondary = {
  main: '#F2F5F8',
  dark: '#DFE6EC',
  contrast: '#000',
}

export const secondaryLkm = {
  main: 'rgba(247,148,28, 0.1)',
  dark: 'rgba(247,148,28, 0.50)',
  contrast: 'F2F5F8',
}

export const action = {
  active: '#808080',
  disabled: '#A6A6A6',
  disabledBackground: '#E0E0E0',
}

export const text = {
  primary: '#000',
  secondary: '#808080',
  disabled: '#BBB',
}

export const background = {
  paper: '#F2F5F8',
  default: '#FFF',
}

export const border = {
  main: '#808080',
}

export const error = {
  main: '#D32F2F',
  dark: '#942121',
  contrast: '#FFF',
}

export const warning = {
  main: '#EE8208',
  dark: '#AD6008',
  contrast: '#FFF',
}

export const success = {
  main: '#61B23B',
  dark: '#2E6116',
  contrast: '#FFF',
}
